// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class TaskResource extends Resource {
    basePath: string = 'tasks/task/';

    objectPath: string = 'tasks/task/{ident}/';
}
